(function($) {

	'use strict';

	function init() {
        initSwiper();
        initKeyboardNav();
	};

    function initSwiper() {

        // Bloc flex crosslink
        createSwiper('.flexCrosslink__repeat', 1.2, 16, {
            1200: {
                slidesPerView: 4,
            }
        });

        // Bloc flex 1 à 4 colonnes
        createSwiper('.flexNumbers__repeat', 1.2, 0, {
            992: {
                slidesPerView: 5,
            }
        });

        // Bloc actualités liées sur les pages "évènement" et "établissement"
        createSwiper('.blockNews__repeat', 1, 20, {
            992: {
                slidesPerView: 3,
            }
        });

        // Bloc slider sur le hero de la page d'accueil
        createSwiper('.hpHero__slider', 1, 30, {});

        // Bloc slider pour les news de la page d'accueil
        createSwiper('.hpNews__repeat', 1, 20, {
            992: {
                slidesPerView: 3,
            }
        });
    }

    function createSwiper(selector, slidesPerView, spaceBetween, breakpoints) {

        const swiper = new Swiper(selector, {
            slidesPerView: slidesPerView,
            spaceBetween: spaceBetween,
            centeredSlides: true,
            pagination: {
              el: '.swiper__pagination',
              clickable: true,
              type: 'bullets',
            },
            navigation: {
                prevEl: '.swiper__arrows__prev',
                nextEl: '.swiper__arrows__next',
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
            },
            breakpoints: breakpoints,
        });

        // Mets à jour la pagination car elle ne fonctionne pas bien
        swiper.on('slideChange', function() {
            let swiperBullets = $(swiper.$el[0]).find('.swiper-pagination-bullet');
            swiperBullets.removeClass("swiper-pagination-bullet-active");
            swiperBullets.eq(swiper.activeIndex).addClass("swiper-pagination-bullet-active");
        });

        return swiper;
    }

    function initKeyboardNav() {
        
        // Permet la navigation des sliders Swiper en utilisant la tabulation
        $('.swiper-slide').focus(function() {
            let slideIndex = $(this).index();
            let swiper = $(this).closest('.swiper-container')[0].swiper;
            
            swiper.slideTo(slideIndex);
        });
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
